import { FlowDefinitionState, FlowProducedType, type FlowStartBlock } from 'flow-schema';
import * as uuid from 'uuid';

import { type ReactFlowBlockNode, type ReactFlowNode } from '../../../../types';
import { BlockType, FlowNodeType } from '../../../types';

export const FLOW_DEFINITION_STATE_TO_SCHEDULED_TRIGGERS_ENABLED: Record<
  FlowDefinitionState,
  'CanScheduleTriggers' | 'CannotScheduleTriggers'
> = {
  [FlowDefinitionState.Draft]: 'CanScheduleTriggers',
  [FlowDefinitionState.Review]: 'CanScheduleTriggers',
  [FlowDefinitionState.Published]: 'CanScheduleTriggers',
  [FlowDefinitionState.SoftDeleted]: 'CannotScheduleTriggers',
  [FlowDefinitionState.Superseded]: 'CannotScheduleTriggers',
};

export const defaultStartNodeLabelPrefix = 'Start';
export function getDefaultStartNodeConfig(): FlowStartBlock['config'] {
  return {
    isStartBlock: true,
    entityType: 'None',
  };
}

export const DEFAULT_START_NODE_POSITION = { x: 4 * 16, y: 8 * 16 };

export function createStartNode(props: Pick<ReactFlowNode, 'position'>): ReactFlowBlockNode {
  return {
    id: uuid.v4(),
    data: {
      uiBlockType: BlockType.Start,
      label: 'Start',
      config: getDefaultStartNodeConfig(),
      returnType: FlowProducedType.Start,
    },
    type: FlowNodeType.Block,
    ...props,
  };
}
